import styled, { css } from 'styled-components';
import { colorTokens } from '../../../tokens/globals/tokens';
import { controllerTokens } from '../../../tokens/components/Controller/tokens';
import shapes from '../../../assets/styled/shapes';

const Aura = styled.label`
  ${shapes.absoluteFullSize()}

  ${({ theme }) =>
    theme.disabled &&
    css`
      cursor: not-allowed;
      background-color: ${controllerTokens.ContainerBackgroundColorDisabledDefault};
      color: ${colorTokens.GlobalBrandGray50};
      -webkit-text-fill-color: ${colorTokens.GlobalBrandGray50};
    `}
`;

export default Aura;
